package com.crowpay.extensions

import com.crowpay.Address

fun Address.isBlank(): Boolean =
    line1.isBlank() || city.isBlank() || zipcode.isBlank()

fun Address.isNotBlank(): Boolean = !isBlank()
